import { Component } from '@verndale/core';
import Swiper, { Navigation, Pagination, A11y } from 'swiper';
import { hideOpacity, showOpacity } from '../helpers/motion';

Swiper.use([Navigation, Pagination, A11y]);

class FeaturedIndividualSwiper extends Component {
  setupDefaults() {
    this.dom = {
      swiperContainer: this.el.querySelector(
        '.home-featured-individuals__swiper-container'
      ),
      swiperSlides: this.el.querySelectorAll(
        '.home-featured-individuals__swiper-slide'
      ),
      swiperButtonPrev: this.el.querySelector(
        '.home-featured-individuals__swiper-btn-prev'
      ),
      swiperButtonNext: this.el.querySelector(
        '.home-featured-individuals__swiper-btn-next'
      )
    };

    this.container = document.querySelector('.container__content');

    this.desktopCards =
      this.dom.swiperSlides.length > 4 ? 4 : this.dom.swiperSlides.length;
    this.landscapeCards =
      this.dom.swiperSlides.length > 4 ? 4 : this.dom.swiperSlides.length;
    this.tabletCards =
      this.dom.swiperSlides.length > 3 ? 3 : this.dom.swiperSlides.length;
    this.mobileTabletCards =
      this.dom.swiperSlides.length > 2 ? 2 : this.dom.swiperSlides.length;

    this.currentBreakpoint = '';
    this.initSlider();
  }

  initSlider() {
    this.swiper = new Swiper(this.dom.swiperContainer, {
      speed: 1000,
      autoHeight: false,
      centeredSlides: true,
      slidesPerView: 1,
      slidesPerGroup: 1,
      breakpoints: {
        420: {
          slidesPerView: this.mobileTabletCards,
          speed: 1500,
          centeredSlides: false
        },
        768: {
          slidesPerView: this.tabletCards,
          speed: 1500,
          centeredSlides: false
        },
        1024: {
          slidesPerView: this.landscapeCards,
          speed: 1500,
          centeredSlides: false
        },
        1440: {
          slidesPerView: this.desktopCards,
          speed: 1500,
          centeredSlides: false
        }
      },
      navigation: {
        prevEl: this.dom.swiperButtonPrev,
        nextEl: this.dom.swiperButtonNext
      },
      a11y: {
        prevSlideMessage: this.el.dataset.previousSlideAriaLabel,
        nextSlideMessage: this.el.dataset.nextSlideAriaLabel
      }
    });

    this.swiper.on('afterInit', this.handleResize.bind(this));
  }

  addListeners() {
    this.swiper.on(
      'activeIndexChange',
      this.handleSlideActiveIndexChange.bind(this)
    );
    this.swiper.on(
      'slideChangeTransitionStart',
      this.handleSlideChangeTransitionStart.bind(this)
    );
    this.swiper.on('resize', this.handleResize.bind(this));
    this.swiper.on('beforeSlideChangeStart', this.handleResize.bind(this));
  }

  handleResize() {
    let breakpoint = false;
    switch (this.swiper.currentBreakpoint) {
      case '420':
        if (this.currentBreakpoint !== 'mobileTablet') {
          this.currentBreakpoint = 'mobileTablet';
          this.visibleCards = this.mobileTabletCards;
          breakpoint = true;
        }
        break;

      case '768':
        if (this.currentBreakpoint !== 'tablet') {
          this.currentBreakpoint = 'tablet';
          this.visibleCards = this.tabletCards;
          breakpoint = true;
        }
        break;

      case '1024':
        if (this.currentBreakpoint !== 'tabletLandscape') {
          this.currentBreakpoint = 'tabletLandscape';
          this.visibleCards = this.landscapeCards;
          breakpoint = true;
        }
        break;

      case '1440':
        if (this.currentBreakpoint !== 'desktop') {
          this.currentBreakpoint = 'desktop';
          this.visibleCards = this.desktopCards;
          breakpoint = true;
        }
        break;

      default:
        if (this.currentBreakpoint !== 'mobile') {
          this.currentBreakpoint = 'mobile';
          this.visibleCards = 1;
          breakpoint = true;
        }
        break;
    }

    if (this.dom.swiperSlides.length <= this.visibleCards) {
      this.dom.swiperButtonNext.style.display = 'none';
      this.dom.swiperButtonPrev.style.display = 'none';
    } else {
      this.dom.swiperButtonNext.style.display = 'flex';
      this.dom.swiperButtonPrev.style.display = 'flex';
    }

    if (breakpoint) {
      this.handleSlideChangeTransitionStart(this.swiper);
      this.handleSlideActiveIndexChange(this.swiper);
    }
  }

  checkNavigationState() {
    if (this.dom.swiperButtonNext.disabled) {
      this.dom.swiperButtonNext.classList.remove('focus-visible');
      this.dom.swiperButtonNext.blur();
    }
    if (this.dom.swiperButtonPrev.disabled) {
      this.dom.swiperButtonPrev.classList.remove('focus-visible');
      this.dom.swiperButtonPrev.blur();
    }
  }

  handleSlideActiveIndexChange(swiper) {
    this.dom.swiperSlides.forEach((element, index) => {
      if (
        index >= swiper.activeIndex &&
        index < swiper.activeIndex + this.visibleCards
      ) {
        if (element.anim) {
          element.anim.stop();
          requestAnimationFrame(() => {
            element.style.visibility = 'visible';
            element.anim = showOpacity(element, 1);
          });
        } else {
          element.style.visibility = 'visible';
          element.anim = showOpacity(element, 1);
        }
      }
    });

    this.checkNavigationState();
  }

  handleSlideChangeTransitionStart(swiper) {
    this.dom.swiperSlides.forEach((element, index) => {
      if (
        index < swiper.activeIndex ||
        index >= swiper.activeIndex + this.visibleCards
      ) {
        if (element.anim) element.anim.stop();
        element.anim = hideOpacity(element, 1, 0.5);
        element.anim.finished.then(() => {
          element.style.visibility = 'hidden';
        });
      }
    });
  }
}

export default FeaturedIndividualSwiper;
